import React from 'react'

/*          
  <SequenceItemUpDown
    arrows={props.arrows}
    itemBefore={props.itemBefore}
    itemAfter={props.itemAfter}
    handleChangeSequence={props.handleChangeSequence}
    itemId={props.itemId}
  />
*/

export default function SequenceItemUpDown(props) {
  if (props.arrows === 'up') {
    return (
      <div>
        <i 
          className='fa fa-arrow-up m2clickable'
          onClick={() => props.handleChangeSequence(props.itemId, props.itemBefore)}
        >
        </i>
      </div>
    )  
  } else if (props.arrows === 'down') {
    return (
      <div>
        <i 
          className='fa fa-arrow-down m2clickable' 
          onClick={() => props.handleChangeSequence(props.itemId, props.itemAfter)}
        >
        </i>
      </div>
    )
  } else if (props.arrows === 'both') {
    return (
      <div>
        <i 
          className='fa fa-arrow-up m2clickable' 
          onClick={() => props.handleChangeSequence(props.itemId, props.itemBefore)}
        >
        </i>
        {' '}
        <i 
          className='fa fa-arrow-down m2clickable' 
          onClick={() => props.handleChangeSequence(props.itemId, props.itemAfter)}
        >
        </i>
      </div>
    )
  } else {
    return <div></div>
  }
}


// WEBPACK FOOTER //
// ./src/components/Content/ManageSetsComponents/SequenceItemUpDown.js